import { render } from "./HistoryRow.vue?vue&type=template&id=0a42890e"
import script from "./HistoryRow.vue?vue&type=script&lang=js"
export * from "./HistoryRow.vue?vue&type=script&lang=js"
script.render = render

export default script